"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactSwipeableViews = _interopRequireDefault(require("react-swipeable-views"));
var _reactSwipeableViewsUtils = require("react-swipeable-views-utils");
var _reactSwipeableViewsCore = require("react-swipeable-views-core");
var _useIsomorphicLayoutEffect = _interopRequireDefault(require("../../../../hooks/useIsomorphicLayoutEffect"));
var _useSlider = _interopRequireDefault(require("../../hooks/useSlider"));
var _types = require("../../types");
var Styled = _interopRequireWildcard(require("./style"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var VirtualizeSwipeableViews = (0, _reactSwipeableViewsUtils.autoPlay)((0, _reactSwipeableViewsUtils.virtualize)(_reactSwipeableViews.default));
var Slides = function Slides(props) {
  var children = props.children,
    className = props.className,
    slideProps = props.slideProps;
  var _a = (0, _useSlider.default)(),
    index = _a.index,
    direction = _a.direction,
    shouldAutoPlay = _a.shouldAutoPlay,
    duration = _a.duration,
    autoWidth = _a.autoWidth,
    slidesLength = _a.slidesLength,
    wrapperRect = _a.wrapperRect,
    loop = _a.loop,
    onChange = _a.onChange,
    setSlidesLength = _a.setSlidesLength,
    getSlideByIndex = _a.getSlideByIndex,
    setSliderInstance = _a.setSliderInstance;
  var slides = (0, _react.useMemo)(function () {
    return _react.Children.toArray(children);
  }, [children]);
  (0, _useIsomorphicLayoutEffect.default)(function () {
    setSlidesLength(slides.length);
  }, [setSlidesLength, slides]);
  var slideRenderer = (0, _react.useCallback)(function (params) {
    var index = params.index,
      key = params.key;
    var slideIndex = (0, _reactSwipeableViewsCore.mod)(index, slides.length);
    return (0, _jsxRuntime.jsx)(Styled.SlideWrapper, __assign({
      autoWidth: autoWidth
    }, slideProps, {
      children: slides[slideIndex]
    }), key);
  }, [slides, autoWidth, slideProps]);
  var containerStyle = {
    width: '100%',
    height: direction === _types.SliderDirections.Vertical ? wrapperRect.height || '100%' : '100%'
  };
  return slidesLength > 0 ? (0, _jsxRuntime.jsx)(VirtualizeSwipeableViews, {
    className: className,
    ref: setSliderInstance,
    resistance: true,
    slideCount: !loop ? slidesLength : undefined,
    interval: duration,
    autoplay: shouldAutoPlay,
    enableMouseEvents: true,
    index: getSlideByIndex(index),
    onChangeIndex: onChange,
    slideRenderer: slideRenderer,
    slideStyle: {
      display: 'flex',
      height: wrapperRect.height || '100%'
    },
    containerStyle: containerStyle,
    style: {
      width: '100%'
    },
    axis: direction === _types.SliderDirections.Vertical ? 'y' : 'x',
    overscanSlideAfter: 5,
    overscanSlideBefore: 5
  }) : null;
};
var _default = Slides;
exports.default = _default;